import { Box, Typography } from "@mui/material";
import { FC, useMemo, useState } from "react";
import ContentCard from "./ContentCard";
import { CMSContentStyles } from "./CMSContentStyles";
import CustomDialog from "../../../../common/CustomDialog/CustomDialog";
import { t } from "i18next";
import { slateToHtml } from "../../../../common/CMS/SlateToHtml/SlateToHtml";
import { formatContentWithStructure } from "../../../../common/CMS/FormatContentWithStructure/FormatContentWithStructure";
import { IContent } from "../../../../models/admin/cms/contentTypes";

export interface ICMSContentProps {
  cmsContent: IContent[];
}

const CMSContent: FC<ICMSContentProps> = ({ cmsContent = [] }) => {
  const [readMoreModalOpen, setReadMoreModalOpen] = useState<boolean>(false);
  const [readMoreTitle, setReadMoreTitle] = useState<string>("");
  const [readMoreContent, setReadMoreContent] = useState<string>("");

  const publishedContent = useMemo(() => {
    const today = new Date();
    const startOfDay = new Date(today.setHours(0, 0, 0, 0));
    const endOfDay = new Date(today.setHours(23, 59, 59, 999));

    if (cmsContent && cmsContent?.length)
      return cmsContent
        ?.filter(
          (item) =>
            !item?.contentTypeName?.toLowerCase().includes("alert") &&
            item?.status?.toLowerCase() === "published" &&
            item?.effectiveStartDate &&
            item?.effectiveEndDate &&
            new Date(item?.effectiveStartDate) <= endOfDay &&
            new Date(item?.effectiveEndDate) >= startOfDay
        )
        ?.map((item) => ({
          ...item,
          fields: {
            ...item.fields,
            Content:
              typeof item.fields?.Content === "string"
                ? item.fields?.Content
                : slateToHtml(item.fields?.Content),
          },
        }));
  }, [cmsContent]);

  const hadleReadMoreDialogClose = () => {
    setReadMoreModalOpen(false);
    setReadMoreTitle("");
  };

  const handleReadMore = async (id: string) => {
    const selectedCard = cmsContent?.filter((item) => item?.id === id);
    setReadMoreModalOpen(true);
    setReadMoreTitle(selectedCard[0]?.fields?.Heading);

    const content = selectedCard[0]?.fields?.Content;
    const rawContent = typeof content === "string" ? content : slateToHtml(content);
    
    const formattedContent = formatContentWithStructure(rawContent);
    setReadMoreContent(formattedContent);
  };

  if (
    !cmsContent ||
    !cmsContent?.length ||
    !cmsContent?.filter(
      (item) => !item?.contentTypeName?.toLowerCase().includes("alert")
    ).length ||
    !publishedContent?.length
  )
    return null;
  return (
    <>
      {publishedContent?.length && (
        <Typography 
          id="cmscontent_quick-references-heading"
          data-test-id="test-cmscontent_quick-references-heading"
          aria-label="Quick References Heading"
          sx={CMSContentStyles.QuickReferencesHeading}
        >
          {t("Quick References For You")}
        </Typography>
      )}
      <Box 
        id="cmscontent_wrapper"
        data-test-id="test-cmscontent_wrapper"
        aria-label="Quick References Content"
        sx={CMSContentStyles?.CMSContentWrapper}
      >
        {publishedContent
          ?.filter(
            (item) => !item?.contentTypeName?.toLowerCase().includes("alert")
          )
          ?.map((item) => {
            return (
              <ContentCard
                key={item?.id}
                id={item?.id}
                imageUrl={item?.fields?.imageUrl || ""}
                Heading={item?.fields?.Heading || ""}
                handleReadMore={handleReadMore}
              />
            );
          })}
      </Box>
      <CustomDialog
        open={readMoreModalOpen}
        onClose={hadleReadMoreDialogClose}
        maxWidth="md"
        title={readMoreTitle}
        content={readMoreContent}
        showDivider={true}
        isRichTextContent={true}
      />
    </>
  );
};

export default CMSContent;
